import React from "react";

/**
 * Minimal Tidle-style loading spinner (Apple-like, centered).
 * Full viewport, dark background; use for auth load, redirect, or permission checks.
 */
function TidleLoadingSpinner() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#171717",
      }}
      aria-label="Loading"
    >
      <div
        style={{
          width: 28,
          height: 28,
          border: "2px solid rgba(255, 255, 255, 0.18)",
          borderTopColor: "rgba(255, 255, 255, 0.7)",
          borderRadius: "50%",
          animation: "tidle-spin 0.7s linear infinite",
        }}
      />
    </div>
  );
}

export default TidleLoadingSpinner;
